import styled from 'styled-components';
import { motion } from 'framer-motion';
import { min } from '../../../theme/breakpoints';

export const PushContainer = styled(motion.div)`
  display: flex;
  flex: 1;
`;

export const PushContent = styled.div`
  background-color: ${({ theme }) => theme.colors.pushBackground};
  flex: 1;
  display: flex;
  flex-direction: column;

  @media screen and ${min('tablet')} {
    flex-direction: row;
    align-items: center;
  }
  @media screen and ${min('largeTablet')} {
    transition: 0.2s all ease-in-out;
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const PushImage = styled.div`
  height: 0;
  width: 100%;
  padding-bottom: 48%;
  position: relative;

  @media screen and ${min('tablet')} {
    width: 42%;
    padding-bottom: 21vw;
  }
  @media screen and ${min('largeTablet')} {
    width: 100%;
    padding-bottom: 48%;
  }
  > div {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`;

export const PushDetails = styled.div`
  width: 100%;
  padding: 1rem;

  @media screen and ${min('tablet')} {
    padding: 1.25rem;
  }
  @media screen and ${min('largeTablet')} {
    padding: 2.5rem;
  }
`;

export const PushTitle = styled.div`
  color: ${({ theme }) => theme.colors.text};
  font-family: ${({ theme }) => theme.fonts.primary.bold};
  text-transform: uppercase;
  font-size: 1.125rem;
  margin-bottom: 1rem;

  @media screen and ${min('largeTablet')} {
    display: flex;
    justify-content: space-between;
    font-size: 1.25rem;
    margin-bottom: 1.5rem;
  }
  .loader {
    display: inline-flex;
  }
`;

export const PushName = styled.div`
  margin-bottom: 0.625rem;

  @media screen and ${min('largeTablet')} {
    margin-bottom: 0;
  }
`;

export const PushPrice = styled.div``;

export const PushActions = styled.div`
  a:not(:last-child) {
    margin-right: 1.5rem;
  }
`;

export const PriceContainer = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
`;

export const DiscountedPrice = styled.div`
  font-size: 1.25rem;
  margin-right: 0.5rem;
  font-family: ${({ theme }) => theme.fonts.primary.regular};

  @media screen and ${min('largeTablet')} {
    font-size: 1.5rem;
    margin-left: 0.5rem;
    margin-right: 0;
  }
`;

interface IBasePriceProps {
  discount?: boolean;
}

export const BasePrice = styled.div<IBasePriceProps>`
  font-size: 1rem;
  font-family: ${({ theme }) => theme.fonts.primary.regular};
  margin-right: 0.5rem;
  text-decoration: ${({ discount }) => (discount ? 'line-through' : 'none')};
  color: ${({ discount, theme }) => (discount ? theme.colors.PaleSky : theme.colors.text)};

  @media screen and ${min('largeTablet')} {
    font-size: 1.25rem;
    margin-left: 0.5rem;
    margin-right: 0;
  }
`;

export const SalePill = styled.span`
  font-family: ${({ theme }) => theme.fonts.primary.bold};
  padding: 2px 0.625rem;
  border-radius: 29px;
  font-size: 0.6875rem;
  color: ${({ theme }) => theme.colors.White};
  background-color: ${({ theme }) => theme.colors.FlushOrange};
  margin-right: 0.5rem;

  @media screen and ${min('largeTablet')} {
    font-size: 0.9375rem;
    padding: 4px 1rem;
    margin-left: 0.5rem;
    margin-right: 0;
  }
`;
